<!-- 
    <select2>
    Select - single
-->
<template>
    <select :name="name" class="form-control-sm">
        <option value="" disabled default>Selecione</option>
        <slot></slot>
    </select>
</template>
<script>
import $ from 'jquery'
import language from '@/helpers/select2PtBr'
export default {
    name: 'select2',
    data(){
        return {
            formatedData: []
        }
    },
    props: ['name', 'options', 'value', 'text', 'refresh', 'url'],
    methods:{
        formatData(dt){ // formata o objeto para o padrão select2
            const self = this
            const format = function(data){
                self.formatedData = data.map(function (obj) {
                    obj.id = obj.id || obj._id;
                    obj.text = typeof obj.label == 'object' ? obj.label[self.text || 'nomeFantasia'] : obj.label
                    
                    if(obj.children){
                        self.formatData(obj.children)
                    }

                    return obj;
                });
                self.formatedData.unshift({id: -1,text: 'Selecione...',disabled: 'disabled', selected: 'selected', search:'', hidden:true})
            }
            
            if(!dt && !self.refresh){
                self.axios.get(self.url).then((dt) => {
                    format(dt.data)
                }).catch((err) => {
                    alert(err)
                })
            } else if (dt.length) {
                format(dt);
            } else {
                self.formatedData = [];
            }
        }
    },
    mounted: function () { // crio a instancia do select
        const vm = this
        
        if(vm.options.length > 0){ // caso exista data options formata e add para : 'this.formatedData'
            vm.formatData(vm.options)
        }
        
        $(vm.$el).select2({ 
            language: language,
            placeholder: 'Selecione...',
            width: '100%',
            data: vm.formatedData,
            allowClear: true
        })
        .val(this.value)
        .trigger('change')
        // emit event on change.
        .on('change', function () {
            vm.$emit('input', this.value) // emit input envia o valor para o v-model
        }).on('select2:select', function () {
            vm.$emit('input', this.value) // caso o change não funcione irá passar por aqui
        }).on('select2:open', function () { // no open verifico se existe um data
            if(vm.formatedData.length > 0){ // so fará o request caso 'vm.formatedData == vazio'
                return false
            }
            let count = 0
            if(!vm.refresh && count <= 1){
                 vm.axios.get(vm.url) // request da lista e add valor para o formatedData
                .then(function(response){
                    vm.formatData(response.data)
                    $(vm.$el).empty().select2({ // recrio o select2 com uma nova data
                        language: language,
                        placeholder: 'Selecione...',
                        width: '100%',
                        allowClear: true,
                        data: vm.formatedData
                    })
                    $(vm.$el).select2('open');
                    vm.$root.$emit(vm.name+'Options', vm.formatedData)
                    count++
                })
                .catch(function(){
                    return false
                });
            }
        })
    },
    watch: {
        value: function (value) { // caso tenha alteração no valor por v-model / alterar valor do input
            $(this.$el)
                .val(value)
                .trigger('change')
        },
        options: function (options) { // caso tenha alteração dos options reescreve o select2
            this.formatData(options)
            const opt = { 
                language: language,
                placeholder: 'Selecione...',
                width: '100%',
                data: this.formatedData,
                allowClear: true
            }

            $(this.$el).empty().select2(opt)
        }
    },
    destroyed: function () {
        $(this.$el).off().select2('destroy')
    }
}
</script>
